import { useState, useEffect } from "react";
import Styles from "./style.module.css";
import { MdArrowBackIos } from "react-icons/md";
import { Navigate, useNavigate } from "react-router";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Load from "Components/Loader/loader";
import { useSearchParams } from "react-router-dom";
import {
    BasicInfo_DependentInfo_add,
    BasicInfo_DependentInfo_get_details,
    BasicInfo_DependentInfo_update,
} from "Services/Requests";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { useStore } from "Store";
import DatePicker from "react-date-picker";

interface Inputs {
    first_name: string;
    middle_name: string;
    last_name: string;
    ssn_itin: string;
    dob: Date | null;
    check_if_itin_to_be_applied: number;
    check_if_ITIN_to_be_renewed: number;
    itin_renewed: number;
    relationship: string;
    visa_status: string;
    no_of_days_stayed_in_us: number;
    lived_for_more_than_06_months: number;
    provided_more_than_50PE_support: number;
    is_you_and_spouse_working: number;
    inst_name: string;
    inst_tax_id: string;
    address: string;
    door_no: string;
    city: string;
    state: string;
    zip: string;
}
function Adddependent() {
    const [searchParams] = useSearchParams();
    const [allData, setData] = useState<any>();
    const { isDisabled, SelectedYear } = useStore((state: any) => state);
    const [isChecked, setIschecked] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            check_if_itin_to_be_applied: 0,
            check_if_ITIN_to_be_renewed: 0,
            itin_renewed: 0,
        },
    });
    const formData = watch();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [oldData, setOldData] = useState<any>([]);

    const [currentYears, setCurrentYears] = useState([
        {
            year: SelectedYear,
            stateOfResidence: "",
            From: null,
            To: null,
            residency_id: 0,
            id: uuidv4(),
            type_of_residency_details: "depedent",
            AddStatus: 1,
        },
    ]);
    const [Past, setPastYears] = useState([
        {
            year: Number(SelectedYear) - 1,
            stateOfResidence: "",
            From: null,
            To: null,
            id: uuidv4(),
            AddStatus: 1,
            residency_id: 0,
            type_of_residency_details: "depedent",
        },
    ]);
    function convertDateToUserTimezone(givenDate: Date): Date {
        const userTimezoneOffset = new Date().getTimezoneOffset() / 60;

        // Remove timezone offset from given date
        const utcDate = new Date(
            givenDate.toLocaleString("en-US", { timeZone: "UTC" })
        );

        // Add user's timezone offset to utcDate
        const userDate = new Date(utcDate);
        userDate.setHours(userDate.getHours() + userTimezoneOffset);

        return userDate;
    }
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await BasicInfo_DependentInfo_get_details(
                searchParams.get("id")
            );
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                setData(response.data.dependent_info);
                reset({
                    ...response.data?.dependent_info,
                    ...response.data.dependent_info.day_care[0],
                    dob:
                        response.data?.dependent_info?.dob &&
                        response.data?.dependent_info?.dob != "0000-00-00" &&
                        convertDateToUserTimezone(
                            response.data?.dependent_info?.dob
                        ),
                });
                if (!isDisabled) {
                    let currentYear =
                        response.data?.dependent_info.residencyDetails_dependent?.filter(
                            (item: any) => item.tax_year == SelectedYear
                        );
                    if (currentYear.length >= 1) {
                        // console.log(currentYear);

                        setCurrentYears(
                            currentYear?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,

                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details,
                            }))
                        );
                    }

                    let pastYear =
                        response.data?.dependent_info.residencyDetails_dependent?.filter(
                            (item: any) =>
                                item.tax_year == Number(SelectedYear) - 1
                        );
                    if (pastYear.length >= 1) {
                        setPastYears(
                            pastYear?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details,
                            }))
                        );
                    }

                    let OldDataNormal =
                        response.data?.dependent_info.residencyDetails_dependent
                            ?.filter(
                                (item: any) =>
                                    item.tax_year != Number(SelectedYear) - 1 &&
                                    item.tax_year != SelectedYear
                            )
                            ?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details,
                            }));
                    setOldData(OldDataNormal);
                } else {
                    setPastYears([]);
                    setCurrentYears(
                        response.data?.dependent_info.residencyDetails_dependent?.map(
                            (item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,

                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details,
                            })
                        )
                    );
                }
            }
        } catch (err: any) {
            console.log(err);
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        if (searchParams.get("id")) {
            GetDetails();
        }
    }, []);

    const addHandler = (type: string) => {
        if (type == "current") {
            setCurrentYears((prev) => [
                ...prev,
                {
                    year: SelectedYear,
                    stateOfResidence: "",
                    From: null,
                    To: null,
                    AddStatus: 1,
                    id: uuidv4(),
                    type_of_residency_details: "depedent",
                    residency_id: 0,
                },
            ]);
        } else {
            setPastYears((prev) => [
                ...prev,
                {
                    year: Number(SelectedYear) - 1,
                    stateOfResidence: "",
                    From: null,
                    To: null,
                    AddStatus: 1,
                    id: uuidv4(),
                    type_of_residency_details: "depedent",
                    residency_id: 0,
                },
            ]);
        }
    };
    console.log(currentYears);
    const removeHandler = (type: string, id: any) => {
        if (type == "current") {
            if (
                currentYears.filter(
                    (item) => item.AddStatus == 1 || item.AddStatus == 2
                ).length > 1
            ) {
                let currentYearData = currentYears.map((item) => {
                    if (item.id == id) {
                        return { ...item, AddStatus: 0 };
                    }
                    return item;
                });
                setCurrentYears(currentYearData);
            }
        } else if (type == "Past") {
            if (
                Past.filter(
                    (item) => item.AddStatus == 1 || item.AddStatus == 2
                ).length > 1
            ) {
                let currentYearData = Past.map((item) => {
                    if (item.id == id) {
                        return { ...item, AddStatus: 0 };
                    }
                    return item;
                });
                setPastYears(currentYearData);
            }
        } else {
            setOldData((prev: any) =>
                prev.map((item: any) =>
                    item.id != id ? item : { ...item, AddStatus: 0 }
                )
            );
        }
    };
    const changeHandler = (
        key: string,
        value: any,
        id: string,
        type: string
    ) => {
        if (type == "current") {
            setCurrentYears((prev) =>
                prev.map((item) =>
                    item.id === id ? { ...item, [key]: value } : item
                )
            );
        } else if (type == "Past") {
            setPastYears((prev) =>
                prev.map((item) =>
                    item.id === id ? { ...item, [key]: value } : item
                )
            );
        } else {
            setOldData((prev: any) =>
                prev.map((item: any) =>
                    item.id === id ? { ...item, [key]: value } : item
                )
            );
        }
    };
    const handleRadioChange = (name: keyof Inputs, value: number) => {
        setValue(name, value);
        if (name === "itin_renewed") {
            setValue("check_if_itin_to_be_applied", 0);
            setValue("check_if_ITIN_to_be_renewed", 0);
        } else if (name === "check_if_itin_to_be_applied") {
            setValue("itin_renewed", 0);
            setValue("check_if_ITIN_to_be_renewed", 0);
        } else if (name === "check_if_ITIN_to_be_renewed") {
            setValue("itin_renewed", 0);
            setValue("check_if_itin_to_be_applied", 0);
        }
    };
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (!isChecked) {
            return;
        }
        let body = {
            dependentInfo: {
                last_name: data.last_name,
                middle_name: data.middle_name,
                first_name: data?.first_name,
                dob: data.dob && moment(data.dob).format("YYYY-MM-DD"),
                ssn_itin: data.ssn_itin,
                check_if_itin_to_be_applied: data.check_if_itin_to_be_applied,
                check_if_ITIN_to_be_renewed: data.check_if_ITIN_to_be_renewed,
                itin_renewed: data.itin_renewed,
                relationship: data.relationship,
                visa_status: data.visa_status,
                no_of_days_stayed_in_us: data.no_of_days_stayed_in_us,
            },
            dayCare: {
                inst_name: data.inst_name,
                inst_tax_id: data.inst_tax_id,
                address: data.address,
                door_no: data.door_no,
                city: data.city,
                state: data.state,
                zip: data.zip,
                id: allData ? allData?.day_care[0].id : "",
            },
            residency_details_for_states: [
                ...currentYears.map((item) => ({
                    tax_year: item.year,
                    states_resided: item.stateOfResidence,

                    start_date: moment(item.From).format("YYYY-MM-DD"),
                    end_date: moment(item.To).format("YYYY-MM-DD"),
                    AddStatus: item.AddStatus,
                    residency_id: item.residency_id,
                    type_of_residency_details: "dependent",
                })),
                ...Past.map((item) => ({
                    tax_year: item.year,
                    states_resided: item.stateOfResidence,

                    start_date: moment(item.From).format("YYYY-MM-DD"),
                    end_date: moment(item.To).format("YYYY-MM-DD"),
                    AddStatus: item.AddStatus,
                    residency_id: item.residency_id,
                    type_of_residency_details: "dependent",
                })),
                ...oldData.map((item: any) => ({
                    tax_year: item.year,
                    states_resided: item.stateOfResidence,

                    start_date: moment(item.From).format("YYYY-MM-DD"),
                    end_date: moment(item.To).format("YYYY-MM-DD"),
                    AddStatus: item.AddStatus,
                    residency_id: item.residency_id,
                    type_of_residency_details: "dependent",
                })),
            ],
        };
        if (searchParams.get("id")) {
            try {
                const [response1] = await Promise.all([
                    BasicInfo_DependentInfo_update(
                        searchParams.get("id"),
                        body
                    ),
                ]);
                setLoading(false);

                if (response1.data.Status == 1) {
                    showSuccessNotification(
                        "Dependent Info Updated successfully"
                    );
                    navigate(-1);
                } else {
                    showWarningAlert(
                        "Something went wrong try again,if Issue persists Contact Support team"
                    );
                }
            } catch (err: any) {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } else {
            try {
                const [response1] = await Promise.all([
                    BasicInfo_DependentInfo_add(body),
                ]);
                setLoading(false);

                if (response1.data.Status == 1) {
                    showSuccessNotification(
                        "Dependent Info Added successfully"
                    );
                    navigate(-1);
                } else {
                    showWarningAlert(
                        "Something went wrong try again,if Issue persists Contact Support team"
                    );
                }
            } catch (err: any) {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        }
    };
    const formatSSN = (value: any) => {
        // console.log(value);
        if (value && value?.length > 0) {
            // Remove all non-digit characters
            const digits = value.replace(/\D/g, "").slice(0, 9);
            let formatted = "";

            if (digits.length > 0) formatted += digits.slice(0, 3); // First 3 digits
            if (digits.length > 3) formatted += "-" + digits.slice(3, 5); // Next 2 digits
            if (digits.length > 5) formatted += "-" + digits.slice(5, 9); // Last 4 digits

            return formatted;
        }
    };

    return (
        <div className={`${Styles["Container"]} `}>
            {loading && <Load />}

            <button onClick={() => navigate(-1)} className={Styles["back-btn"]}>
                <MdArrowBackIos />
                Back to Dependent Info
            </button>
            <form action="" onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["info"]}>
                    <h3>Dependent Info </h3>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">First Name</label>
                        <input
                            disabled={isDisabled}
                            className={
                                errors?.first_name && Styles["error-input"]
                            }
                            type="text"
                            {...register("first_name", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                            placeholder="Enter First Name"
                        />
                        {errors?.first_name && (
                            <p>{errors?.first_name?.message}</p>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Middle Name</label>
                        <input
                            disabled={isDisabled}
                            className={
                                errors?.middle_name && Styles["error-input"]
                            }
                            type="text"
                            {...register("middle_name", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                            placeholder="Middle Name"
                        />
                        {errors?.middle_name && (
                            <p>{errors?.middle_name?.message}</p>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">last Name</label>
                        <input
                            disabled={isDisabled}
                            className={
                                errors?.last_name && Styles["error-input"]
                            }
                            type="text"
                            {...register("last_name", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                            placeholder="Enter Last Name"
                        />
                        {errors?.last_name && (
                            <p>{errors?.last_name?.message}</p>
                        )}
                    </div>

                    <div
                        className={`${Styles["form-date"]} ${Styles["add_dependant_formcontrol"]}`}>
                        <label htmlFor="">Date of Birth</label>
                        <Controller
                            disabled={isDisabled}
                            control={control}
                            name="dob"
                            render={({ field }) => (
                                <DatePicker
                                    clearIcon={false}
                                    yearPlaceholder="YYYY"
                                    monthPlaceholder="MM"
                                    dayPlaceholder="DD"
                                    className={Styles["date-picker-custom"]}
                                    {...field}
                                    onKeyDown={(e) => e.preventDefault()}
                                    disabled={field.disabled}
                                    // clearIcon={false}
                                    format="MM/dd/yyyy"
                                    calendarIcon={<span>📅</span>}
                                />
                            )}
                        />
                        {errors?.dob && <p>DOB is required</p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Relationship</label>
                        <select
                            disabled={isDisabled}
                            className={
                                errors?.relationship && Styles["error-input"]
                            }
                            {...register("relationship", { required: false })}>
                            <option value="">Please select</option>
                            <option value="Daughter">Daughter</option>
                            <option value="Son">Son</option>
                            <option value="Mother">Mother</option>
                            <option value="Father">Father</option>
                            <option value="Father-in-Law">Father in Law</option>
                            <option value="Mother-in-Law">Mother in Law</option>
                            <option value="other">Other</option>
                        </select>
                        {errors?.relationship && <p>Relation is required</p>}
                    </div>
                    <div
                        className={Styles["form-control"]}
                        style={{ gridColumn: "1/-1" }}>
                        <label htmlFor="">IRS Status</label>
                        <div className={Styles["notification"]}>
                            <div>
                                <input
                                    disabled={isDisabled}
                                    type="radio"
                                    name="Notification"
                                    value="SSN"
                                />
                                <label htmlFor="javascript">SSN</label>
                            </div>
                            <div>
                                <input
                                    disabled={isDisabled}
                                    type="radio"
                                    name="Notification"
                                    value="ITIN"
                                    checked={formData.itin_renewed == 1}
                                    onChange={(e) =>
                                        handleRadioChange(
                                            "itin_renewed",
                                            e.target.checked ? 1 : 0
                                        )
                                    }
                                />
                                <label htmlFor="ITIN">ITIN</label>
                            </div>
                            <div>
                                <input
                                    disabled={isDisabled}
                                    type="radio"
                                    name="Notification"
                                    value="Applying ITIN"
                                    checked={
                                        formData.check_if_itin_to_be_applied ==
                                        1
                                    }
                                    onChange={(e) =>
                                        handleRadioChange(
                                            "check_if_itin_to_be_applied",
                                            e.target.checked ? 1 : 0
                                        )
                                    }
                                />
                                <label htmlFor="ITIN">Applying ITIN</label>
                            </div>
                            <div>
                                <input
                                    disabled={isDisabled}
                                    type="radio"
                                    name="Notification"
                                    value="Renewing ITIN"
                                    checked={
                                        formData?.check_if_ITIN_to_be_renewed ==
                                        1
                                    }
                                    onChange={(e) =>
                                        handleRadioChange(
                                            "check_if_ITIN_to_be_renewed",
                                            e.target.checked ? 1 : 0
                                        )
                                    }
                                />
                                <label htmlFor="ITIN">Renewing ITIN</label>
                            </div>
                        </div>
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Dependent Visa Type</label>
                        <select
                            disabled={isDisabled}
                            id=""
                            className={
                                errors?.visa_status && Styles["error-input"]
                            }
                            {...register("visa_status", {
                                required: false,
                            })}>
                            <option value="">Please select</option>
                            <option value="F1">F1</option>
                            <option value="F2">F2</option>
                            <option value="H1">H1</option>
                            <option value="H4">H4</option>
                            <option value="L1">L1</option>
                            <option value="L2">L2</option>
                            <option value="B1">B1</option>
                            <option value="B2">B2</option>
                            <option value="J1">J1</option>
                            <option value="J2">J2</option>
                            <option value="us_citizen">U.S Citizen</option>
                            <option value="green_card">Green Card</option>
                        </select>
                        {errors?.visa_status && (
                            <span style={{ color: "red" }}>
                                Visa Type is required
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Days stayed in US</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            className={
                                errors?.no_of_days_stayed_in_us &&
                                Styles["error-input"]
                            }
                            {...register("no_of_days_stayed_in_us", {
                                required: false,
                            })}
                        />
                        {errors?.no_of_days_stayed_in_us && (
                            <span style={{ color: "red" }}>
                                this is required
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">SSN/ITIN</label>
                        {/*   <input disabled={isDisabled}
                                type="number"
                                className={
                                    errors?.ssn_itin && Styles["error-input"]
                                }
                                {...register("ssn_itin", {
                                    required: false,
                                })}
                                /> */}

                        <Controller
                            name="ssn_itin"
                            control={control}
                            defaultValue=""
                            rules={{
                                pattern: {
                                    value: /^\d{3}-\d{2}-\d{4}$/,
                                    message:
                                        "Invalid format. Use XXX-XX-XXXX for SSN or ITIN",
                                },
                            }}
                            render={({
                                field: { onChange, onBlur, value, ref },
                            }) => (
                                <input
                                    disabled={isDisabled}
                                    ref={ref}
                                    value={formatSSN(value)}
                                    onChange={(e) => {
                                        const formattedValue: any = formatSSN(
                                            e.target.value
                                        );
                                        const cursorPosition =
                                            e.target.selectionStart ?? 0;
                                        onChange(formattedValue);
                                        setTimeout(() => {
                                            const inputElement = e.target;
                                            // Adjust the cursor position after formatting
                                            let newCursorPosition =
                                                cursorPosition;

                                            // Handle cursor positioning when hyphens are added or removed
                                            // The cursor moves to the right after each character typed, accounting for hyphens

                                            if (
                                                formattedValue &&
                                                formattedValue[
                                                    cursorPosition - 1
                                                ] === "-" &&
                                                !formattedValue[
                                                    cursorPosition + 1
                                                ] &&
                                                formattedValue.length >
                                                    formData.ssn_itin?.length &&
                                                cursorPosition > 1
                                            ) {
                                                newCursorPosition++; // If cursor was on a hyphen, move it right
                                            }
                                            inputElement.setSelectionRange(
                                                newCursorPosition,
                                                newCursorPosition
                                            ); // Set cursor next to typed character
                                        }, 0);
                                    }}
                                    onBlur={onBlur}
                                    className={
                                        errors.ssn_itin ? "error-input" : ""
                                    }
                                    placeholder=" SSN/ITIN (XXX-XX-XXXX)"
                                />
                            )}
                        />
                        {errors.ssn_itin && (
                            <span style={{ color: "red" }}>
                                {errors.ssn_itin.message}
                            </span>
                        )}
                    </div>
                    {/*   <div className={Styles["Dependent-info"]}>
                        <p>Dependent Info</p>
                        <div
                            className={Styles["form-control"]}
                            style={{ gridColumn: "1/-1" }}>
                            <label htmlFor="">IRS Status</label>
                            <div className={Styles["notification"]}>
                                <div>
                                    <input disabled={isDisabled}
                                        type="radio"
                                        name="Notification"
                                        value="SSN"
                                    />
                                    <label htmlFor="javascript">SSN</label>
                                </div>
                                <div>
                                    <input disabled={isDisabled}
                                        type="radio"
                                        name="Notification"
                                        value="ITIN"
                                        checked={formData.itin_renewed == 1}
                                        onChange={(e) =>
                                            handleRadioChange(
                                                "itin_renewed",
                                                e.target.checked ? 1 : 0
                                            )
                                        }
                                    />
                                    <label htmlFor="ITIN">ITIN</label>
                                </div>
                                <div>
                                    <input disabled={isDisabled}
                                        type="radio"
                                        name="Notification"
                                        value="Applying ITIN"
                                        checked={
                                            formData.check_if_itin_to_be_applied ==
                                            1
                                        }
                                        onChange={(e) =>
                                            handleRadioChange(
                                                "check_if_itin_to_be_applied",
                                                e.target.checked ? 1 : 0
                                            )
                                        }
                                    />
                                    <label htmlFor="ITIN">Applying ITIN</label>
                                </div>
                                <div>
                                    <input disabled={isDisabled}
                                        type="radio"
                                        name="Notification"
                                        value="Renewing ITIN"
                                        checked={
                                            formData?.check_if_ITIN_to_be_renewed ==
                                            1
                                        }
                                        onChange={(e) =>
                                            handleRadioChange(
                                                "check_if_ITIN_to_be_renewed",
                                                e.target.checked ? 1 : 0
                                            )
                                        }
                                    />
                                    <label htmlFor="ITIN">Renewing ITIN</label>
                                </div>
                            </div>
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">Dependent Visa Type</label>
                            <select disabled={isDisabled}
                                id=""
                                className={
                                    errors?.visa_status && Styles["error-input"]
                                }
                                {...register("visa_status", {
                                    required: false,
                                })}>
                                <option value="">Please select</option>
                                <option value="F1">F1</option>
                                <option value="F2">F2</option>
                                <option value="H1">H1</option>
                                <option value="H4">H4</option>
                                <option value="L1">L1</option>
                                <option value="L2">L2</option>
                                <option value="B1">B1</option>
                                <option value="B2">B2</option>
                                <option value="J1">J1</option>
                                <option value="J4">J4</option>
                                <option value="us_citizen">U.S Citizen</option>
                                <option value="green_card">Green Card</option>
                            </select>
                            {errors?.visa_status && (
                                <span style={{ color: "red" }}>
                                    Visa Type is required
                                </span>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">Days stayed in US</label>
                            <input disabled={isDisabled}
                                type="number"
                                className={
                                    errors?.no_of_days_stayed_in_us &&
                                    Styles["error-input"]
                                }
                                {...register("no_of_days_stayed_in_us", {
                                    required: false,
                                })}
                            />
                            {errors?.no_of_days_stayed_in_us && (
                                <span style={{ color: "red" }}>
                                    this is required
                                </span>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">SSN/ITIN</label>
                            

                            <Controller
                                name="ssn_itin"
                                control={control}
                                defaultValue=""
                                rules={{
                                    pattern: {
                                        value: /^\d{3}-\d{2}-\d{4}$/,
                                        message:
                                            "Invalid format. Use XXX-XX-XXXX for SSN or ITIN",
                                    },
                                }}
                                render={({ field }) => (
                                    <input disabled={isDisabled}
                                        {...field}
                                        className={
                                            errors?.ssn_itin &&
                                            Styles["error-input"]
                                        }
                                        placeholder=" SSN/ITIN (XXX-XX-XXXX)"
                                    />
                                )}
                            />
                            {errors.ssn_itin && (
                                <span style={{ color: "red" }}>
                                    {errors.ssn_itin.message}
                                </span>
                            )}
                        </div>
                    </div> */}
                </div>
                <div className={Styles["info-tax"]}>
                    <h3>Residential Address(es) during tax year</h3>
                    <div className={Styles["table-wrapper"]}>
                        <table className={Styles["tax-years"]}>
                            <thead className={Styles["tax-heading"]}>
                                <tr>
                                    <th>Tax Year</th>
                                    <th>State of Residence</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Option</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentYears
                                    .filter(
                                        (item) =>
                                            item.AddStatus == 1 ||
                                            item.AddStatus == 2
                                    )
                                    .map((item) => (
                                        <tr>
                                            <td>{item.year}</td>
                                            <td
                                                className={
                                                    Styles["stateResidence"]
                                                }>
                                                <input
                                                    disabled={isDisabled}
                                                    onChange={(e) =>
                                                        changeHandler(
                                                            "stateOfResidence",
                                                            e.target.value,
                                                            item.id,
                                                            "current"
                                                        )
                                                    }
                                                    type="text"
                                                    placeholder="State of residence"
                                                    value={
                                                        item.stateOfResidence
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    clearIcon={false}
                                                    yearPlaceholder="YYYY"
                                                    monthPlaceholder="MM"
                                                    dayPlaceholder="DD"
                                                    className={
                                                        Styles[
                                                            "date-picker-custom"
                                                        ]
                                                    }
                                                    disabled={isDisabled}
                                                    value={item.From}
                                                    onChange={(date) =>
                                                        changeHandler(
                                                            "From",
                                                            date,
                                                            item.id,
                                                            "current"
                                                        )
                                                    }
                                                    calendarIcon={
                                                        <span>📅</span>
                                                    }
                                                    format="MM/dd/yyyy"
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    clearIcon={false}
                                                    yearPlaceholder="YYYY"
                                                    monthPlaceholder="MM"
                                                    dayPlaceholder="DD"
                                                    value={item.To}
                                                    onChange={(date) =>
                                                        changeHandler(
                                                            "To",
                                                            date,
                                                            item.id,
                                                            "current"
                                                        )
                                                    }
                                                    className={
                                                        Styles[
                                                            "date-picker-custom"
                                                        ]
                                                    }
                                                    calendarIcon={
                                                        <span>📅</span>
                                                    }
                                                    format="MM/dd/yyyy"
                                                    disabled={isDisabled}
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    className={
                                                        Styles["action-btns"]
                                                    }>
                                                    <button
                                                        disabled={isDisabled}
                                                        type="button"
                                                        onClick={() =>
                                                            addHandler(
                                                                "current"
                                                            )
                                                        }>
                                                        +
                                                    </button>
                                                    <button
                                                        disabled={isDisabled}
                                                        type="button"
                                                        onClick={() => {
                                                            removeHandler(
                                                                "current",
                                                                item.id
                                                            );
                                                        }}>
                                                        -
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                {Past.filter(
                                    (item) =>
                                        item.AddStatus == 1 ||
                                        item.AddStatus == 2
                                ).map((item) => (
                                    <tr>
                                        <td>{item.year}</td>
                                        <td
                                            className={
                                                Styles["stateResidence"]
                                            }>
                                            <input
                                                disabled={isDisabled}
                                                onChange={(e) =>
                                                    changeHandler(
                                                        "stateOfResidence",
                                                        e.target.value,
                                                        item.id,
                                                        "Past"
                                                    )
                                                }
                                                type="text"
                                                placeholder="State of residence"
                                                value={item.stateOfResidence}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                clearIcon={false}
                                                yearPlaceholder="YYYY"
                                                monthPlaceholder="MM"
                                                dayPlaceholder="DD"
                                                className={
                                                    Styles["date-picker-custom"]
                                                }
                                                value={item.From}
                                                onChange={(date) =>
                                                    changeHandler(
                                                        "From",
                                                        date,
                                                        item.id,
                                                        "Past"
                                                    )
                                                }
                                                format="MM/dd/yyyy"
                                                calendarIcon={<span>📅</span>}
                                                disabled={isDisabled}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                clearIcon={false}
                                                yearPlaceholder="YYYY"
                                                monthPlaceholder="MM"
                                                dayPlaceholder="DD"
                                                value={item.To}
                                                className={
                                                    Styles["date-picker-custom"]
                                                }
                                                onChange={(date) =>
                                                    changeHandler(
                                                        "To",
                                                        date,
                                                        item.id,
                                                        "Past"
                                                    )
                                                }
                                                calendarIcon={<span>📅</span>}
                                                format="MM/dd/yyyy"
                                                disabled={isDisabled}
                                            />
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["action-btns"]
                                                }>
                                                <button
                                                    type="button"
                                                    disabled={isDisabled}
                                                    onClick={() =>
                                                        addHandler("Past")
                                                    }>
                                                    +
                                                </button>
                                                <button
                                                    disabled={isDisabled}
                                                    type="button"
                                                    onClick={() => {
                                                        removeHandler(
                                                            "Past",
                                                            item.id
                                                        );
                                                    }}>
                                                    -
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {oldData
                                    .filter(
                                        (item: any) =>
                                            item.AddStatus == 1 ||
                                            item.AddStatus == 2
                                    )
                                    .map((item: any) => (
                                        <tr>
                                            <td>{item.year}</td>
                                            <td
                                                className={
                                                    Styles["stateResidence"]
                                                }>
                                                <input
                                                    disabled={isDisabled}
                                                    onChange={(e) =>
                                                        changeHandler(
                                                            "stateOfResidence",
                                                            e.target.value,
                                                            item.id,
                                                            "old"
                                                        )
                                                    }
                                                    type="text"
                                                    placeholder="State of residence"
                                                    value={
                                                        item.stateOfResidence
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    clearIcon={false}
                                                    yearPlaceholder="YYYY"
                                                    monthPlaceholder="MM"
                                                    dayPlaceholder="DD"
                                                    className={
                                                        Styles[
                                                            "date-picker-custom"
                                                        ]
                                                    }
                                                    value={item.From}
                                                    onChange={(date) =>
                                                        changeHandler(
                                                            "From",
                                                            date,
                                                            item.id,
                                                            "old"
                                                        )
                                                    }
                                                    format="MM/dd/yyyy"
                                                    calendarIcon={
                                                        <span>📅</span>
                                                    }
                                                    disabled={isDisabled}
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    clearIcon={false}
                                                    yearPlaceholder="YYYY"
                                                    monthPlaceholder="MM"
                                                    dayPlaceholder="DD"
                                                    value={item.To}
                                                    className={
                                                        Styles[
                                                            "date-picker-custom"
                                                        ]
                                                    }
                                                    onChange={(date) =>
                                                        changeHandler(
                                                            "To",
                                                            date,
                                                            item.id,
                                                            "old"
                                                        )
                                                    }
                                                    calendarIcon={
                                                        <span>📅</span>
                                                    }
                                                    format="MM/dd/yyyy"
                                                    disabled={isDisabled}
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    className={
                                                        Styles["action-btns"]
                                                    }>
                                                    <button
                                                        disabled={isDisabled}
                                                        type="button"
                                                        onClick={() => {
                                                            removeHandler(
                                                                "old",
                                                                item.id
                                                            );
                                                        }}>
                                                        -
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={Styles["info"]}>
                    <h3>
                        Day Care Details <br />
                        <span
                            style={{
                                fontWeight: "500",
                                fontSize: "0.9rem",
                            }}>
                            Fees paid to a licensed day care center or family
                            day care for care of an infant or pre-schooler
                        </span>
                    </h3>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Institution Name</label>
                        <input
                            disabled={isDisabled}
                            className={
                                errors?.inst_name && Styles["error-input"]
                            }
                            {...register("inst_name", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                            type="text"
                            placeholder="Enter Institution Name"
                        />
                        {errors?.inst_name && (
                            <p>{errors?.inst_name?.message} </p>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Institution Tax ID</label>
                        <input
                            disabled={isDisabled}
                            typeof="number"
                            className={
                                errors?.inst_tax_id && Styles["error-input"]
                            }
                            {...register("inst_tax_id", { required: false })}
                            type="text"
                            placeholder="Enter Institution Tax ID"
                        />
                        {errors?.inst_tax_id && <p>This is required </p>}
                    </div>{" "}
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Mailing Address</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Mailing address"
                            className={errors?.address && Styles["error-input"]}
                            {...register("address", { required: false })}
                        />
                        {errors?.address && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Door No</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Apartment"
                            className={errors?.door_no && Styles["error-input"]}
                            {...register("door_no", { required: false })}
                        />
                        {errors?.door_no && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">City</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter City name"
                            className={errors?.city && Styles["error-input"]}
                            {...register("city", { required: false })}
                        />
                        {errors?.city && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">State</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter State "
                            className={errors?.state && Styles["error-input"]}
                            {...register("state", { required: false })}
                        />
                        {errors?.state && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Zipcode</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter Zipcode "
                            {...register("zip", { required: false })}
                            className={errors?.zip && Styles["error-input"]}
                        />
                    </div>
                    <div
                        className={Styles["declaration"]}
                        style={{ gridColumn: "1/-1" }}>
                        <h3>
                            <input
                                disabled={isDisabled}
                                type="checkbox"
                                id="pushNotification"
                                onChange={(e) => setIschecked(e.target.checked)}
                            />
                            <label
                                htmlFor="pushNotification"
                                className={Styles["checkbox-label"]}>
                                I declare that the information in this
                                application is true and correct{" "}
                            </label>
                        </h3>
                        <div className={Styles["save-btns"]}>
                            <button disabled={isDisabled || !isChecked}>
                                Save
                            </button>
                            {/* <button type="button">Reset</button> */}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Adddependent;
